import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const PaypalIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-3.8 0 27 18"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fill={color}
        d="m16.1901 6.40039-.0522.30276c-.689 3.51835-3.0276 4.72935-6.0239 4.72935h-1.52426c-.17644.0004-.34695.0636-.48091.1785-.13396.1148-.22257.2736-.2499.4479l-.78301 4.9486-.21924 1.399c-.00916.0557-.006.1127.00927.1671s.04226.1047.07909.1475.08259.077.13406.1002.10741.0349.16386.0341h2.70399c.15505.002.30565-.0516.42445-.1513.1188-.0996.1978-.2386.2228-.3916v-.1357l.5012-3.226v-.1775c.0227-.1549.1008-.2963.2198-.3981.119-.1017.2709-.1568.4274-.1552h.4072c2.6205 0 4.6667-1.044 5.22-4.176.1609-.52815.1955-1.08666.1012-1.63062-.0942-.54397-.3149-1.05823-.644-1.50143-.1838-.20327-.3988-.37596-.6369-.51156z"
        fill-opacity=".45"
      />
      <Path
        fill={color}
        d="m8.74809 6.4218c.02246-.15313.09906-.29315.21589-.39466.11684-.10152.26618-.1578.42095-.15866h4.07167c.4507-.00462.901.0268 1.3467.09396l.3446.06264.3236.08352h.1566c.1942.0643.3828.14462.5638.24012.132-.51726.1374-1.05875.0156-1.57853-.1217-.51979-.367-1.00254-.7151-1.40733-.7726-.87697-2.1716-1.26325-3.9568-1.26325h-5.22005c-.17643.00035-.34695.06363-.48091.17845-.13395.11482-.22256.27365-.2499.44795l-2.15066 13.77049c-.00889.0631-.00425.1274.01362.1886.01788.0612.04858.1178.09006.1662s.0928.0874.15052.1144c.05773.0271.12055.0415.18429.0423h3.2051l.80389-5.1052z"
      />
    </Svg>
  )
}

export default PaypalIconSvg
